enum ReportView {
  Date = 'Date',
  Week = 'Week',
  Month = 'Month',
  Quarter = 'Quarter',
  Channel = 'Channel',
  Device = 'Device',
  Advertiser = 'Advertiser',
  Campaign = 'Campaign',
  Placement = 'Placement',
  Creative = 'Creative',
  Publisher = 'Publisher',
  DaysOfWeek = 'Days of Week',
  Daypart = 'Daypart',
  Deals = 'Deals',
  ContentNetwork = 'Content Network',
  ContentChannel = 'Content Channel',
  GeoFence = 'Geo-Fence',
  App = 'App',
  //#region esm
  Platform = 'Platform',
  AdGroup = 'Ad Group',
  Keyword = 'Keyword',
  Agency = 'Agency',
  AdName = 'Ad Name',
  //#endregion
}

export default ReportView;
